export const roleBadge: Record<string, string> = {
  super_admin: 'badge-red',
  badarts_administrator: 'badge-purple',
  ligue_representative: 'badge-indigo',
  comitee_representative: 'badge-orange',
  tournament_manager: 'badge-primary',
  club_representative: 'badge-green',
  player: 'badge-teal',
  user: 'badge-gray',
};

export const roleLabel: Record<string, string> = {
  super_admin: 'Super Admin',
  badarts_administrator: 'Admin Badarts',
  ligue_representative: 'Admin Ligue',
  comitee_representative: 'Admin Comité',
  tournament_manager: 'Organisateur',
  club_representative: 'Représentant club',
  player: 'Joueur',
  user: 'Utilisateur',
};
